import React from 'react';
import withRoot from "../../../withRoot";
import CheckoutEmision from "./Checkout";
import useStyles from "./Checkout/styles";
import Header from "../../../adviser/Dashboard/Header";
import Title from "../../../customer/ProductsCustomer/Title";
import ByPolko from "../../../customer/ByPolko";


function Emision(props) {
    const classes = useStyles();
    return (
        <React.Fragment>
            <div className={classes.divBackground}>

                <div className={classes.divHeader}>
                    <Header role={"Asesor"}/>
                </div>

                <div className={classes.divTitle}>
                    <Title
                        title={"SEGUROS"}
                        subtitle={"¡Emita un seguro de motovehículo en 4 simples pasos!"}
                    />
                </div>

                <div className={classes.formBox}>
                    {typeof props.location.state !== 'undefined'
                        ? (<CheckoutEmision
                            continueCotizacion={true}
                            emisionValues={props.location.state.emisionValues}
                            applyDiscounts={!props.location.state.recotizar}
                        />)
                        : (<CheckoutEmision continueCotizacion={false} emisionValues={null} applyDiscounts={true}/>)}
                </div>

                <div className={classes.divByPolko}>
                    <ByPolko fontSize={25}/>
                </div>
            </div>
        </React.Fragment>
    )
}

export default withRoot(Emision);
